/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2020 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  IcecontrolSettings,
  IcemattableSettings,
  IcepanelgroupSettings,
  IcepanelsectionSettings,
  IcepanelSettings,
  IcepanelcontainerRowSettings,
  IcepanelcontainerSettings,
  iceColumnDefinition
} from '../../../../icemedx-lib/src/components/models/icesettings';
import { IIceEntity } from '../../../../icemedx-lib/src/models/core/IceEntity';
import { IBaseView } from '../../../../icemedx-lib/src/components/baseview.component';
import { message } from '../../../../icemedx-lib/src/models/messages/message';
import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { IcepanelService } from '../../../../icemedx-lib/src/components/icepanel/icepanel.service';
import { MessageService } from '../../../../icemedx-lib/src/services/message/message.service';
import { XmlparseService } from '../../../../icemedx-lib/src/services/xml/xmlparse.service';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { AppService } from '../app.service';
import { MedicalcodesService } from 'projects/icemedx-lib/src/services/medicalcodes/medicalcodes.service';
import { DomainService } from 'projects/icemedx-lib/src/services/domain/domain.service';
import { NewmessageComponent } from '../newmessage/newmessage.component';

@Component({
  selector: 'forwardmessage',
  templateUrl: './forwardmessage.component.html',
  styleUrls: ['./forwardmessage.component.scss'],
  providers: [IcepanelService, MessageService, XmlparseService, IceNavService, AppService]
})
export class ForwardmessageComponent extends NewmessageComponent implements OnInit {

  constructor(router: Router,
    appSvc: AppService,
    medicalCodesService: MedicalcodesService,
    loginSvc: LoginService,
    messageService: MessageService,
    domainSvc: DomainService,
    navSvc: IceNavService,
    activatedRoute: ActivatedRoute) {
    super(router, appSvc, medicalCodesService, loginSvc, messageService, domainSvc, navSvc, activatedRoute);
  }

  ngOnInit() {
    this.getAppService().refreshMenus();
  }

  viewSetup(dat: IIceEntity): IcepanelcontainerSettings {
    this.setPanelHeading("Forward To");
    this.setPanelTag("ForwardMessage");
    this.setPanelKeyg(Iceutility.guid(false));
    return super.viewSetup(dat);
  }
}
